import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var updateContractDelSlice = createSlice({
    name: "updateContractDel",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updateContractDelSlice_actions = updateContractDelSlice.actions;
export var fetchData = _updateContractDelSlice_actions.fetchData, fetchDataSuccess = _updateContractDelSlice_actions.fetchDataSuccess, fetchDataFailure = _updateContractDelSlice_actions.fetchDataFailure, resetState = _updateContractDelSlice_actions.resetState;
export default updateContractDelSlice.reducer;
